import { defineAction } from '~/prix'
import fetchQuestionnaireAnswersAction from './questionnaireFetchQuestions.action.json' with { type: 'json' }
import { z } from 'zod'

const fetchQuestionnaireAnswersDefinition = defineAction({
  ...fetchQuestionnaireAnswersAction,

  input: z.object({
    questionnaireId: z.coerce.number(),
  }),
  output: z.object({}),
})

export default fetchQuestionnaireAnswersDefinition
